module.exports = __webpack_public_path__ + "img/tj.71c18cc6.svg";